import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  centered = true,
  light = false
}: SectionHeadingProps) {
  return <div className={`mb-12 ${centered ? 'text-center' : 'text-left'}`} data-id="element-188">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${light ? 'text-white' : 'text-[#0f5f5f]'}`} data-id="element-189">
        {title}
      </motion.h2>
      {subtitle && <motion.p initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.1
    }} className={`text-lg md:text-xl max-w-3xl mx-auto ${light ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-190">
          {subtitle}
        </motion.p>}
      <motion.div initial={{
      scaleX: 0
    }} whileInView={{
      scaleX: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8,
      delay: 0.2
    }} className={`h-1 w-24 bg-[#d4a74a] mt-6 ${centered ? 'mx-auto' : ''}`} data-id="element-191" />
    </div>;
}